import { render } from "./dialog-prohibit-record.vue?vue&type=template&id=cb3278aa&scoped=true"
import script from "./dialog-prohibit-record.vue?vue&type=script&lang=js"
export * from "./dialog-prohibit-record.vue?vue&type=script&lang=js"

import "./dialog-prohibit-record.vue?vue&type=style&index=0&id=cb3278aa&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3278aa"]])

export default __exports__